import axios from "axios";

export const initAxios = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
};

export const setAuthHeaders = (token: string) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};
